import { render, staticRenderFns } from "./FinalSubmitDraftModal.vue?vue&type=template&id=0c9a91b2&"
import script from "./FinalSubmitDraftModal.vue?vue&type=script&lang=js&"
export * from "./FinalSubmitDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./FinalSubmitDraftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports